var song_structure = require('../visuals/song-structure');
var colors = require('./colors');

var canvas = $('#rugs')[0];
paper.setup(canvas);

window.paths = [];
var path = null;
window.stems = [];
var stem = [];

var finished = false;

var VOL_BASE = 3;
var VOL_MULTIPLIER = 30;

var TRACK_MULTIPLIERS = [
	1,
	1,
	3,
	1,
	1,
	3,
	1,
	1,
	1
];

// pull in audio streams
var audio_stream = require('../streams/audio_stream');
var stream_data = [];
var stream_total_vol = 0;
audio_stream.stream.onValue( function(val) {
	stream_data = val;
	stream_total_vol = val.reduce(function(sum, item) {
		return sum + item;
	}, 0);
});

// index
var num_of_paths = -1;
var has_dragged = false;

// "the dot"
// var dot = new paper.Shape.Circle(100,100,10);
// dot.fillColor = '#FFFFFF';
// dot.opacity = 0;

// ======================================================
// VISUAL CHANGES
// ======================================================

var fill_color = '#ffffff';
var bg_color = '#000000';
var $body = $('body');
var sine_waveys = false;
var displacement = false;

song_structure.onValue(function(item) {
	if (!item) return;
	if (item.actions.indexOf('color') > -1)        change_color();
	if (item.actions.indexOf('sine_on') > -1)      sine(true);
	if (item.actions.indexOf('sine_off') > -1)     sine(false);
	if (item.actions.indexOf('displacement') > -1) displace();
});

function change_color() {
	bg_color = colors.fill();
	$body[0].style.background = bg_color;
}

function sine(flag) {
	sine_waveys = flag;
}

function displace() {
	displacement = true;
}

// ======================================================
// MOUSE EVENTS
// ======================================================

module.exports.start = function start(event) {
	path = new paper.Path();
	path.fillColor = fill_color;

	var seg = new paper.Segment();
	seg.point = new paper.Point(event.point);
	path.add(seg);

	num_of_paths++;
	paths.push(path);
	stems.push([]);
	stems[num_of_paths].push({
		point: seg,
		first: true
	});

	has_dragged = false;
}

module.exports.drag = function drag(event) {
	// create the points
	var step = event.delta.normalize(10);
	step.angle += 90;
	
	var top = event.middlePoint.add(step);
	var bottom = event.middlePoint.subtract(step);

	// use the points to create segments
	var topseg = new paper.Segment();
	topseg.point = new paper.Point(top);
	var bottomseg = new paper.Segment();
	bottomseg.point = new paper.Point(bottom);
	
	// add the segments to the path and the stem
	path.add(topseg);
	path.insert(0, bottomseg);
	path.smooth();

	stems[num_of_paths].push({
		point: new paper.Point(event.middlePoint),
		delta: new paper.Point(event.delta),
		top: topseg,
		bottom: bottomseg
	});

	has_dragged = true;
	// update_dot(event);
}

module.exports.end = function end(event) {
	var seg = new paper.Segment();
	seg.point = new paper.Point(event.point);

	path.add(seg);
	path.closed = true;
	path.smooth();

	stems[num_of_paths].push({
		point: seg,
		last: true
	});

	if (!has_dragged) {
		path.remove();
		stems[num_of_paths].pop();
		num_of_paths--;
	}
	// update_dot(event, true);
}

module.exports.stop = function() {
	finished = true;
}

// ======================================================
// RENDER
// ======================================================

var frame_index = 0;
module.exports.render = function render() {
	if (finished) return paper.view.update();
	frame_index++;
	window.requestAnimationFrame(render);
	stems.forEach( function(stem, i) {
		stem.forEach( function(item, item_index) {
			if(!item.first && !item.last) {
				var vol = stream_data[i % stream_data.length];
				var step = item.delta.normalize(
					VOL_BASE + vol*VOL_MULTIPLIER * TRACK_MULTIPLIERS[i%stream_data.length]
				);
				step.angle += 90;

				var middle_mod;
				if (item_index <= stem.length/2) {
					middle_mod = item_index / (stem.length/2);
				} else {
					middle_mod = 2 - (item_index / (stem.length/2));
				}

				var x_mod = 0;
				var y_mod = 0;
				if (sine_waveys) {
					x_mod = ((Math.random() * 30) - 15) * stream_total_vol * middle_mod;
					y_mod = ((Math.random() * 30) - 15) * stream_total_vol * middle_mod;
				}

				if (displacement) {
					x_mod += (stream_total_vol * 12) * ((frame_index%2===0)?1:-1);
					y_mod += (stream_total_vol * 12) * ((frame_index%2===0)?-1:1);
				}

				var top = {
					x: item.point.x + step.x + x_mod,
					y: item.point.y + step.y + y_mod
				};
				var bottom = {
					x: item.point.x - step.x + x_mod,
					y: item.point.y - step.y + y_mod
				};

				item.top.point = top;
				item.bottom.point = bottom;
			}
		});
	});

	paper.view.update();
};

// ======================================================
// DOT MOVEMENT
// ======================================================

// function update_dot(event, end) {
// 	if (event.point) {
// 		dot.setPosition(event.point);
// 	} else {
// 		dot.setPosition(event);
// 	}
// 	if (end) {
// 		dot.opacity = 0;
// 	} else {
// 		dot.opacity = 0.2;
// 	}
// }

module.exports.render();